import Checkout from "../components/checkout/checkout";
import { Link } from "react-router-dom";
import "../components/checkout/checkout.css";

// component tạo trang checkout
function CheckoutPage() {
  return (
    <section className="Co_page">
      {/* tạo breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/cart">Giỏ hàng</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Checkout
          </li>
        </ol>
      </nav>
      <h3 className="text-primary ms-5">CHECKOUT</h3>

      <Checkout />
    </section>
  );
}

export default CheckoutPage;
